import React from 'react';
import NewsCard from './NewsCard';
import { EmptyState } from '../common/ErrorMessage';

const NewsGrid = ({ news, category }) => {
  if (!news || news.length === 0) {
    return <EmptyState message="Bu kategoride henüz haber bulunmuyor." />;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {news.map((item, index) => (
        <NewsCard key={item.id || index} news={item} category={category} />
      ))}
    </div>
  );
};

export default NewsGrid;
